import dealerAddress from './dealerAddress';
import widgetInfo from './widgetInfo';
import account from './account';
import pricingModuleData from './pricingModule';
import userProfile from './userProfile';

const root = {
	dealerAddress,
	widgetInfo,
	account,
	pricingModuleData,
	userProfile
};

export default root;
